"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var MemberPage_1 = require("@/pages/common/components/MemberPage");
var react_redux_1 = require("react-redux");
var MyProperty_1 = require("@/pages/myproperty/components/MyProperty");
var myViewing = function (props) {
    var renderEmpty = function (props) {
        return (React.createElement("div", { className: "c-document__empty" },
            React.createElement("div", { className: "c-document__empty-icon" },
                React.createElement("span", { className: "fal fa-check" })),
            React.createElement("div", { className: "c-document__empty-caption" }, props.t.myViewingEmpty)));
    };
    var renderMyViewing = function (props) {
        return (React.createElement("div", { id: "myviewing", className: "l-container__main", style: { maxWidth: '100%' } },
            MyProperty_1.renderReportSold(props),
            React.createElement("div", { style: { maxWidth: '1000px' } },
                React.createElement("div", { className: "l-pad-content" },
                    React.createElement("div", { className: "c-page-header c-page-header--center-mobile" },
                        React.createElement("div", { className: "c-page-header__body" },
                            React.createElement("div", { className: "c-page-header__title" }, props.t.myViewingsTitle),
                            React.createElement("div", { className: "c-page-header__caption" }, props.t.myViewingCaption))),
                    MyProperty_1.renderSearchBar(props),
                    props.eformProperties == null || props.eformProperties.length == 0 ? null : MyProperty_1.renderPropertyResultHead(props),
                    props.isLoading ? MyProperty_1.renderLoading(props) : (props.eformProperties == null || props.eformProperties.length == 0 ? renderEmpty(props) : MyProperty_1.renderEformPropertyResult(props))))));
    };
    return (React.createElement(MemberPage_1.default, null, renderMyViewing(props)));
};
exports.default = react_redux_1.connect(MyProperty_1.mapStateToProps, MyProperty_1.mapDispatchToProps)(myViewing);
